import { render, staticRenderFns } from "./PolicySells.vue?vue&type=template&id=49f8df51&scoped=true&"
import script from "./PolicySells.vue?vue&type=script&lang=js&"
export * from "./PolicySells.vue?vue&type=script&lang=js&"
import style0 from "./PolicySells.vue?vue&type=style&index=0&id=49f8df51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8df51",
  null
  
)

export default component.exports